(() => {
  // Bundle cards: drive Dawn's hidden variant input for the bundle option.
  document.addEventListener('click', (event) => {
    const card = event.target.closest('.gj-bundle');
    if (!card) return;
    const wrap = card.closest('.gj-bundles');
    const productInfo = card.closest('product-info');
    if (card.dataset.qty) {
      wrap.querySelectorAll('.gj-bundle').forEach((el) => {
        el.classList.toggle('is-active', el === card);
        el.setAttribute('aria-pressed', el === card);
      });
      const qty = productInfo.querySelector('.quantity__input');
      if (qty) {
        qty.value = card.dataset.qty;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      renderMix(wrap, parseInt(card.dataset.qty, 10));
      return;
    }
    const optionName = wrap.dataset.optionName;
    const value = card.dataset.value;

    wrap.querySelectorAll('.gj-bundle').forEach((el) => {
      el.classList.toggle('is-active', el === card);
      el.setAttribute('aria-pressed', el === card);
    });

    const inputs = productInfo.querySelectorAll(`variant-selects input[data-option-name="${CSS.escape(optionName)}"]`);
    const input = [...inputs].find((el) => el.value === value);
    if (input) {
      if (input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const select = [...productInfo.querySelectorAll('variant-selects select')].find((el) =>
      el.querySelector(`option[data-option-name="${CSS.escape(optionName)}"]`)
    );
    if (select) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Delivery timeline: skip weekends when adding business days.
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  document.querySelectorAll('.gj-delivery').forEach((el) => {
    const now = new Date();
    const n = (key) => parseInt(el.dataset[key], 10) || 0;
    el.querySelector('[data-gj-date="ordered"]').textContent = fmt(now);
    el.querySelector('[data-gj-date="shipped"]').textContent =
      `${fmt(addBusinessDays(now, n('processMin')))} – ${fmt(addBusinessDays(now, n('processMax')))}`;
    el.querySelector('[data-gj-date="delivered"]').textContent =
      `${fmt(addBusinessDays(now, n('shipMin')))} – ${fmt(addBusinessDays(now, n('shipMax')))}`;
  });

  // Rotating mini reviews.
  document.querySelectorAll('.gj-mini-reviews').forEach((wrap) => {
    const items = wrap.querySelectorAll('.gj-mini-review');
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 5000);
  });

  // Sticky add to cart: show once the main button scrolls out of view.
  const sticky = document.querySelector('.gj-sticky');
  const mainButton = document.querySelector('product-info .product-form__submit');
  if (sticky && mainButton) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainButton);
    sticky.querySelector('[data-gj-sticky-buy]').addEventListener('click', () => {
      const button = document.querySelector('product-info .product-form__submit');
      if (button && !button.disabled) button.click();
      else button?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        const price = document.querySelector('product-info [id^="price-"] .price__regular .price-item, product-info [id^="price-"] .price-item--sale');
        const shown = document.querySelector('product-info [id^="price-"] .price--on-sale .price-item--sale') || price;
        if (shown) sticky.querySelector('[data-gj-sticky-price]').textContent = shown.textContent.trim();
      });
    }
  }
})();

// Mix & match: one Character + Size picker per romper when a 2- or 3-romper card is chosen.
const mixData = (wrap) => {
  if (!wrap._mixData) wrap._mixData = JSON.parse(wrap.querySelector('.gj-mix__data').textContent);
  return wrap._mixData;
};

const currentOptions = (wrap) => {
  const info = wrap.closest('product-info');
  const picked = [...info.querySelectorAll('variant-selects input:checked, variant-selects select')].map((el) => el.value);
  return picked.length ? picked : mixData(wrap).variants[0].options;
};

function renderMix(wrap, qty) {
  const box = wrap.querySelector('.gj-mix');
  if (!box) return;
  const rows = box.querySelector('.gj-mix__rows');
  box.hidden = qty < 2;
  wrap.closest('product-info')?.classList.toggle('gj-mix-on', qty > 1);
  rows.innerHTML = '';
  if (qty < 2) return;
  const { options, variants } = mixData(wrap);
  const characters = [...new Set(variants.map((v) => v.options[0]))];
  const first = currentOptions(wrap);
  for (let i = 0; i < qty; i++) {
    // Default each extra romper to a different character so the mix is obvious.
    const startChar = i === 0 ? first[0] : characters[(characters.indexOf(first[0]) + i) % characters.length];
    const row = document.createElement('div');
    row.className = 'gj-mix__row';
    row.innerHTML =
      `<span class="gj-mix__num">${i + 1}</span>` +
      `<select class="gj-mix__char" aria-label="Romper ${i + 1} ${options[0]}">${characters
        .map((c) => `<option value="${c}"${c === startChar ? ' selected' : ''}>${c.replace(/^The /, '')}</option>`)
        .join('')}</select>` +
      `<select class="gj-mix__size" aria-label="Romper ${i + 1} ${options[1]}"></select>`;
    rows.appendChild(row);
    const fillSizes = (preferred) => {
      const char = row.querySelector('.gj-mix__char').value;
      const sizes = variants.filter((v) => v.options[0] === char && v.available);
      const sel = row.querySelector('.gj-mix__size');
      sel.innerHTML = sizes
        .map((v) => `<option value="${v.id}"${v.options[1] === preferred ? ' selected' : ''}>${v.options[1]}</option>`)
        .join('');
    };
    fillSizes(first[1]);
    row.querySelector('.gj-mix__char').addEventListener('change', () => fillSizes(first[1]));
  }
}

// When a multi-romper bundle is active, add each picked romper as its own cart line.
window.addEventListener(
  'submit',
  async (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    const wrap = form.closest('product-info, .shopify-section')?.querySelector('.gj-bundles--qty') || document.querySelector('.gj-bundles--qty');
    const box = wrap && wrap.querySelector('.gj-mix');
    if (!box || box.hidden) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const counts = {};
    box.querySelectorAll('.gj-mix__size').forEach((sel) => {
      if (sel.value) counts[sel.value] = (counts[sel.value] || 0) + 1;
    });
    const items = Object.entries(counts).map(([id, quantity]) => ({ id: Number(id), quantity }));
    const button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-disabled', 'true');
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (res.ok) {
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } else {
      if (button) button.removeAttribute('aria-disabled');
      const err = await res.json().catch(() => ({}));
      alert(err.description || 'Sorry, one of those sizes just sold out. Please pick another.');
    }
  },
  true
);

// Christmas cutoff countdown ([countdown] in announcement + urgency text, see snippets/cm-countdown.liquid).
(() => {
  const els = [...document.querySelectorAll('.cm-countdown')];
  if (!els.length) return;
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    els.forEach((el) => {
      const left = new Date(el.dataset.deadline) - Date.now();
      if (left <= 0) {
        const line = el.closest('p') || el.parentElement;
        line.textContent = el.dataset.after;
        line.closest('.gj-urgency')?.classList.add('is-closed');
        return;
      }
      const s = Math.floor(left / 1000);
      const d = Math.floor(s / 86400);
      el.textContent = `${d ? `${d}d ` : ''}${pad(Math.floor(s / 3600) % 24)}h ${pad(Math.floor(s / 60) % 60)}m ${pad(s % 60)}s`;
    });
  };
  tick();
  setInterval(tick, 1000);
})();

// Limited sizes note: "Only 6-12M & 12-18M left in The Reindeer" for characters with fewer sizes in stock.
(() => {
  const data = document.querySelector('.gj-mix__data');
  if (!data) return;
  const { options, variants } = JSON.parse(data.textContent);
  const ci = options.findIndex((o) => /character/i.test(o));
  if (ci < 0) return;
  const sizes = {};
  variants.filter((v) => v.available).forEach((v) => (sizes[v.options[ci]] ||= []).push(v.options[1 - ci]));
  const max = Math.max(...Object.values(sizes).map((s) => s.length));
  const lines = Object.entries(sizes)
    .filter(([, s]) => s.length < max)
    .map(([name, s]) => `Only ${s.join(' & ')} left in ${name}`);
  if (!lines.length) return;
  const place = () => {
    // Dawn swaps variant-selects on every option change; drop notes left behind by the old one.
    document.querySelectorAll('.cm-stock-note').forEach((n) => {
      if (n.previousElementSibling?.tagName !== 'VARIANT-SELECTS') n.remove();
    });
    document.querySelectorAll('variant-selects').forEach((vs) => {
      if (vs.nextElementSibling?.classList.contains('cm-stock-note')) return;
      const note = document.createElement('p');
      note.className = 'cm-stock-note';
      note.textContent = `🦌 ${lines.join(' · ')}`;
      vs.after(note);
    });
  };
  place();
  new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
})();
